import { SpwkUtilV3 } from "../dao/SpwkUtilV3";
import { new_ErrorAlert } from "./ExportManager";
import { GovRow } from "./GovRow";
import { SpwkGovStep } from "./GovRowHelper";
import { 申報通用解碼 } from "./GovRowParser_既往病史_自覺症狀";
import { HisBasic } from "./HisBasic";
import { SpwkMetaTable } from "./SpwkMetaTable";

export class GovRowParser_環境監測 {

  static ConvertToHisRow(func_code: string, step: SpwkGovStep, 基本檔: HisBasic, meta_table: SpwkMetaTable): GovRow[] {

    if (step.Chapter !== SpwkUtilV3.CHAPTER_環境監測) {
      throw new Error("5984985 必須是 CHAPTER_環境監測 !!!");
    }

    if (func_code === SpwkUtilV3.A01_func_guid || func_code === SpwkUtilV3.A98_func_guid) {
      throw new_ErrorAlert("4164646 A01、A98 還沒有轉申報格式 !!!")
    }

    let re: GovRow[] = [];

    if (NotNeed環境監測(func_code) === true) {
      return re;// 不需要環境監測的問卷
    }
    let q_meta_list = meta_table.FilterQuestions_ByChapter(SpwkUtilV3.CHAPTER_環境監測);

    for (const q_meta of q_meta_list) {
      if (q_meta.q_gov_code == null || q_meta.q_gov_code === "") {
        continue;  // pass; 目前不處理沒有指定申報代碼的題目
      }

      const gov_row = 申報通用解碼(q_meta, 基本檔, step, meta_table);
      re.push(gov_row);

      /* 特殊規則，有勾 登錄系統 時，補上 "事業單位編號" FIXME: 改乾淨一點 */
      if (q_meta.code === "登錄系統" && gov_row.答題內容 === "10") {

        let meta = meta_table.FindQuestionMeta_ByChapterAndCode(SpwkUtilV3.CHAPTER_環境監測, "事業單位編號");
        if (meta == null) {
          throw new_ErrorAlert("預期要有 Q事業單位編號 !!!");
        }


        let q_guid = meta.question_guid;
        let q_inputs = meta_table.FilterInputs_ByQuestionGuid(q_guid);

        if (q_inputs.length !== 1 || q_inputs[0].code !== "1") {
          throw new_ErrorAlert("預期要有 事業單位編號 Input !!!");
        }

        gov_row.答題內容_1 = q_inputs[0].rhf_value ?? "";// 事業單位編號

      }


    }

    return re;
  }

}


function NotNeed環境監測(func_code: string) {
  // TODO: A01 A98 B04 B21 B22 B28 B30 B31 沒有第七大題
  // TODO: B03 沒有第七大題，長得不一樣 但是多一大題
  let no_ch7_func_codes = ["A01", "A98", "B04", "B21", "B22", "B28", "B29" ,"B30", "B31"];
  if (no_ch7_func_codes.includes(func_code)) {
    return true;
  } else {
    return false;
  }
}